<div class="g-top-nav">
  <img src="assets/img/logo.svg" alt="Logo Menutech" />
  <p class="g-top-nav-text body-2">
    {{ 'login.use' | transloco }}
    <a href="https://menu.menutech.com/" target="_blank">{{
      'login.menutech' | transloco
    }}</a>
    {{ 'login.access-credentials' | transloco }}
  </p>
</div>
